import { Box, ThemeUIStyleObject } from 'theme-ui'

import { trimHTMLFormattedText, truncateText } from 'src/lib/formatting'
import Type from 'src/components/gel/Type'

const TRUNCATE_TEXT_LENGTH = 462

const FormattedText = ({
  text,
  truncateLength,
  typeStyles
}: {
  text: string
  truncateLength?: number
  typeStyles?: ThemeUIStyleObject
}) => {
  const formattedText = truncateText(
    trimHTMLFormattedText(text),
    truncateLength || TRUNCATE_TEXT_LENGTH
  )
  return (
    <Box sx={{ height: 'auto', overflow: 'hidden' }}>
      <Type
        as="div"
        variant="Body"
        className="bullet-points"
        dangerouslySetInnerHTML={{
          __html: formattedText
        }}
        sx={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          ...typeStyles
        }}
      />
    </Box>
  )
}

export default FormattedText
